module.exports = __webpack_public_path__ + "static/mtb-5-eae532165b1c9d0e02cf0858f985c652.jpg";